// Tab-separated-values codec for clipboard interop with Excel / Google Sheets.
//
// Columns are tab-separated, rows CRLF-separated. A cell containing a tab, newline or double
// quote is wrapped in double quotes with embedded quotes doubled (""), exactly like CSV. This
// is why cells can safely hold JSON-encoded rich text / arrays: quoting survives the round-trip.

function escapeCell(s: string): string {
	if (/[\t\r\n"]/.test(s)) return '"' + s.replace(/"/g, '""') + '"'
	return s
}

export function toTSV(rows: string[][]): string {
	return rows.map(row => row.map(escapeCell).join('\t')).join('\r\n')
}

// Parse pasted text into a matrix of strings. Handles quoted fields with embedded tabs,
// newlines and doubled quotes, and both LF and CRLF row separators.
export function fromTSV(text: string): string[][] {
	const rows: string[][] = []
	let row: string[] = []
	let field = ''
	let inQuotes = false
	let i = 0
	const n = text.length

	while (i < n) {
		const ch = text[i]
		if (inQuotes) {
			if (ch === '"') {
				if (text[i + 1] === '"') { field += '"'; i += 2; continue }
				inQuotes = false; i++; continue
			}
			field += ch; i++; continue
		}
		if (ch === '"') { inQuotes = true; i++; continue }
		if (ch === '\t') { row.push(field); field = ''; i++; continue }
		if (ch === '\r' || ch === '\n') {
			row.push(field); field = ''; rows.push(row); row = []
			if (ch === '\r' && text[i + 1] === '\n') i += 2; else i++
			continue
		}
		field += ch; i++
	}
	// flush the trailing field/row
	row.push(field)
	rows.push(row)

	// drop a single empty trailing row produced by a terminal newline
	if (rows.length > 1) {
		const last = rows[rows.length - 1]
		if (last.length === 1 && last[0] === '') rows.pop()
	}
	return rows
}
